import { render, staticRenderFns } from "./ResponseDetail.vue?vue&type=template&id=384af986"
import script from "./ResponseDetail.vue?vue&type=script&lang=js"
export * from "./ResponseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports